/**
 * The one availability nudge (business lead, 2026-10-27): from the prompt day (setting availability_prompt_day,
 * default the 24th) a rep with no available day yet in NEXT month sees this on every portal page, until they add at
 * least one. Before that day it asks about the current month if it is still empty. In-app only, no email. The rule is
 * server-side (msr_availability_prompt, migration 1150).
 */
import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import {
  getAvailabilityPrompt,
  monthLabel,
} from "../../services/msrFeedback.service";

const MsrAvailabilityPrompt: React.FC = () => {
  const { data } = useQuery({
    queryKey: ["msr-availability-prompt"],
    queryFn: getAvailabilityPrompt,
    retry: false,
    staleTime: 60_000,
  });
  if (!data?.show || !data.month) {
    return null;
  }
  return (
    <div
      className="mt-3 flex flex-col gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 sm:flex-row sm:items-center sm:justify-between"
      role="status"
      data-testid="msr-availability-prompt"
    >
      <p className="text-sm text-amber-900">
        <strong>Add your availability for {monthLabel(data.month)}.</strong>{" "}
        Your manager needs to know which days you can work.
      </p>
      <Link
        to={`/msr/availability?month=${data.month.slice(0, 7)}`}
        className="inline-flex min-h-[40px] items-center justify-center rounded-md bg-amber-600 px-3 text-sm font-semibold text-white hover:bg-amber-700"
      >
        Add availability
      </Link>
    </div>
  );
};

export default MsrAvailabilityPrompt;
